import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module.js';
import { PdfPageComponent } from './pdf-page.component.js';
import { WorkoutsModule } from "../../modules/workouts/workouts.module.js";
import { LayoutModule } from "../../layout/layout.module.js";
import { DietsModule } from "../../modules/diets/diets.module.js";
import { UsersModule } from "../../modules/users/users.module.js";

@NgModule({
    declarations: [PdfPageComponent],
    exports: [PdfPageComponent],
    imports: [CoreModule, WorkoutsModule, LayoutModule, DietsModule, UsersModule]
})
export class PdfModule {}
